import { render, staticRenderFns } from "./projectAdd.vue?vue&type=template&id=15a15e52&scoped=true&"
import script from "./projectAdd.vue?vue&type=script&lang=js&"
export * from "./projectAdd.vue?vue&type=script&lang=js&"
import style0 from "./projectAdd.vue?vue&type=style&index=0&id=15a15e52&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a15e52",
  null
  
)

export default component.exports